const identifyingGAPath = 'identifyingGA.';

const identifyingGATrans = {
    WATCH_AND_DISCOVER: identifyingGAPath + 'watchAndDiscover',
    WATCH_AND_DISCOVER_DESCRIPTION: identifyingGAPath + 'discoverContent',
    GA_BY_NUMBERS: identifyingGAPath + 'gaByNumbers',

    GA_IRREVERSIBLE_TITLE: identifyingGAPath + "gaIrreversibleTitle",
    GA_IRREVERSIBLE_SUB_TITLE: identifyingGAPath + "gaIrreversibleSubTitle",
    GA_IRREVERSIBLE_DESCRIPTION: identifyingGAPath + "gaIrreversibleDescription",
    GA_IRREVERSIBLE_IMAGE_DESC: identifyingGAPath + "gaIrreversibleImageDescription",

    HALLMARK_TITLE: identifyingGAPath + "hallmarkTitle",
    HALLMARK_DESCRIPTION: identifyingGAPath + "hallmarkDescription",
    HALLMARK_NOTES: identifyingGAPath + "hallmarkNotes",

    INTERMEDIATE_DISEASE_TITLE: identifyingGAPath + "intermediateDiseaseTitle",
    INTERMEDIATE_DISEASE_DESCRIPTION: identifyingGAPath + "intermediateDiseaseDescription",
    INTERMEDIATE_DISEASE_NOTES: identifyingGAPath + "intermediateDiseaseNotes",

    LESION_AREAS_TITLE: identifyingGAPath + "lesionAreasTitle",
    LESION_AREAS_DESCRIPTION: identifyingGAPath + "lesionAreasDescription",
    LESION_AREAS_NOTES: identifyingGAPath + "lesionAreasNotes",

    PROGRESSION_TITLE: identifyingGAPath + "progressionTitle",
    PROGRESSION_DESCRIPTION: identifyingGAPath + "progressionDescription",
    PROGRESSION_NOTES: identifyingGAPath + "progressionNotes"
}

export default identifyingGATrans